<script>
	import Router, { link, push, location as browserLocation} from "svelte-spa-router";
	import { replace } from "svelte-spa-router";
	import { routes } from "./routes.js";
	import { setContext } from "svelte";
	import { User, Language } from "@Store";
	import jwt_decode from 'jwt-decode';
	import Logo from "@assets/logo.png";
	let token = localStorage.getItem("insurecert_token");
	$: if(token){
		$User = jwt_decode(token);
	}

	export let program;

	setContext("PROGRAM",{program})

	let showRestartModal = false;

	function openRestartModal() {
		showRestartModal = true;
	}

	function closeRestartModal() {
		showRestartModal = false;
	}

    function confirmRestart() {
        localStorage.removeItem('policyID')
        replace(`/`);
        setTimeout(()=>{
        	window.location.reload();
        },100)
    }

	function logout() {
		localStorage.removeItem('insurecert_token')
		window.location.reload()
	}

	let showResourcesDropdown = false;
	
	function toggleResourcesDropdown() {
		showResourcesDropdown = !showResourcesDropdown;
	}
	
	function closeResourcesDropdown() {
		showResourcesDropdown = false;
	}
	
	// Close dropdown when clicking outside
	function handleClickOutside(event) {
		if (showResourcesDropdown && !event.target.closest('.resources-dropdown')) {
			closeResourcesDropdown();
		}
	}
	
</script>
<svelte:body on:click={handleClickOutside} />
<header class="app-header">
	<div class="header-container">
		<div class="brand">
			<a href="https://cand.ca/" target="_blank" rel="noopener noreferrer" class="brand-link">
				<img src="{Logo}" alt="CAND Insurance" class="brand-logo" />
				<span class="brand-name">CAND Insurance</span>
			</a>
		</div>
		
		<!-- Around line 52-95, fix the duplicate header tag -->
		<nav class="nav-actions">
			<button class="header-button secondary" on:click={openRestartModal}>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
					<path d="M13.65 2.35A7.5 7.5 0 1 0 8 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
					<path d="M13 2.5V6h-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				{$Language === 'en' ? 'Restart' : 'Recommencer'}
			</button>
			
			{#if $User}
				<button class="header-button primary" on:click={() => push('/dashboard')}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
					</svg>
					{$Language === 'en' ? 'Dashboard' : 'Tableau de bord'}
				</button>
				<button class="header-button secondary" on:click={() => logout()}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M10 2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2M6 12l-4-4m0 0l4-4m-4 4h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					{$Language === 'en' ? 'Logout' : 'Déconnexion'}
				</button>
			{:else}
				<button class="header-button primary" on:click={() => push('/dashboard')}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M11 7v2a3 3 0 0 1-6 0V7a3 3 0 0 1 6 0Z" stroke="currentColor" stroke-width="1.5"/>
						<path d="M8 12v2m-3 0h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
					</svg>
					{$Language === 'en' ? 'Login' : 'Connexion'}
				</button>
			{/if}

			<!-- NEW RESOURCES DROPDOWN -->
			<div class="resources-dropdown">
				<button class="header-button secondary" on:click|stopPropagation={toggleResourcesDropdown}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
						<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/>
					</svg>
					{$Language === 'en' ? 'Resources' : 'Ressources'}
					<svg class="dropdown-chevron" class:open={showResourcesDropdown} width="12" height="12" viewBox="0 0 12 12" fill="none">
						<path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</button>
				
				{#if showResourcesDropdown}
					<div class="dropdown-menu">
						<a href="https://cand.ipmgainsurance.com/policy-wording/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M9 2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6m-4-4l4 4m-4-4v4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span>{$Language === 'en' ? 'Policy Wordings' : 'Libellés de la police'}</span>
						</a>
						
						<a href="https://cand.ipmgainsurance.com/faqs/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/>
								<path d="M8 11h.01M8 8a1 1 0 0 1 1-1c.5 0 1-.5 1-1s-.5-1-1-1-1 .5-1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
							<span>{$Language === 'en' ? 'FAQs' : 'FAQ'}</span>
						</a>
						
						<a href="https://cand.ipmgainsurance.com/glossary/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M4 2h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" stroke="currentColor" stroke-width="1.5"/>
								<path d="M5 5h6M5 8h6M5 11h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
							<span>{$Language === 'en' ? 'Glossary' : 'Glossaire'}</span>
						</a>
					</div>
				{/if}
			</div>
			
			<!-- REMOVED the duplicate <header class="app-header"> tag that was here -->
			<button class="lang-toggle" on:click={() => $Language = $Language === 'en' ? 'fr' : 'en'}>
				<svg class="globe-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
					<path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2"/>
				</svg>
				<span class="lang-text">{$Language === 'en' ? 'FR' : 'EN'}</span>
			</button>
			<!-- REMOVED the closing </header> tag that was here -->
		</nav>
	</div>
</header>

<main class="app-main">
	<Router {routes}/>
</main>

<!-- Restart Confirmation Modal -->
{#if showRestartModal}
	<div class="modal-overlay" on:click={closeRestartModal}>
		<div class="modal-content" on:click|stopPropagation>
			<div class="modal-icon">
				<svg width="48" height="48" viewBox="0 0 48 48" fill="none">
					<circle cx="24" cy="24" r="20" stroke="#0071e3" stroke-width="2"/>
					<path d="M24 16v12M24 32h.01" stroke="#0071e3" stroke-width="2.5" stroke-linecap="round"/>
				</svg>
			</div>
			
			<h2 class="modal-title">Start Over?</h2>
			<p class="modal-message">
				This will clear your current application and start a new one. All progress will be lost.
			</p>
			
			<div class="modal-actions">
				<button class="modal-button cancel" on:click={closeRestartModal}>
					Cancel
				</button>
				<button class="modal-button confirm" on:click={confirmRestart}>
					Start Over
				</button>
			</div>
		</div>
	</div>
{/if}

<style>
	:global(body) {
		margin: 0;
		padding: 0;
		background: #f5f5f7;
		--base-green: #316832;
		--base-green-light: #428442;
		--base-green-lightest: #acd4ac;
		--base-blue: #437c90;
		--base-blue-light: #6996a6;
		--base-blue-lightest: #8eb0bc;
		--gold: #e3a125;
		--red: #ac3931;
		--dark: #14262b;
		--light: #f9f2e8;
	}

	.app-header {
		position: sticky;
		top: 0;
		left: 0;
		right: 0;
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(20px) saturate(180%);
		-webkit-backdrop-filter: blur(20px) saturate(180%);
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
		z-index: 1000;
		width: 100%;
	}

	.header-container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 1rem 2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.brand {
		display: flex;
		align-items: center;
		gap: 0.75rem;
	}

	.brand-logo {
		height: 50px;
		width: auto;
		object-fit: contain;
	}

	.brand-name {
		font-size: 1.25rem;
		font-weight: 600;
		color: #1d1d1f;
		letter-spacing: -0.02em;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.brand-link {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		text-decoration: none;
		transition: opacity 0.2s ease;
	}

	.brand-link:hover {
		opacity: 0.7;
	}

	.brand-link:hover .brand-logo {
		transform: scale(1.02);
		transition: transform 0.2s ease;
	}

	.nav-actions {
		display: flex;
		gap: 0.75rem;
		align-items: center;
	}

	.header-button {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem 1rem;
		font-size: 0.9375rem;
		font-weight: 500;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.lang-toggle {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 0.875rem;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        border: 2px solid #e9ecef;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }

    .lang-toggle:hover {
        border-color: #0071e3;
        background: #fff;
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(0, 113, 227, 0.15);
    }

    .globe-icon {
        width: 18px;
        height: 18px;
        color: #0071e3;
    }

    .lang-text {
        font-size: 0.875rem;
        font-weight: 600;
        color: #1d1d1f;
        letter-spacing: 0.02em;
    }


	.header-button.primary {
		background: var(--base-green);
		color: white;
	}

	.header-button.primary:hover {
		background: var(--base-green-light);
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 113, 227, 0.3);
	}

	.header-button.secondary {
		background: transparent;
		color: #1d1d1f;
	}

	.header-button.secondary:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.header-button:active {
		transform: translateY(0);
	}

	.app-main {
		padding-top: 1rem;
	}

	/* Modal Styles */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.4);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 2000;
		animation: fadeIn 0.2s ease;
	}

	@keyframes fadeIn {
		from { opacity: 0; }
		to { opacity: 1; }
	}

	.modal-content {
		background: white;
		border-radius: 20px;
		padding: 2rem;
		max-width: 400px;
		width: 90%;
		text-align: center;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
		animation: slideUp 0.3s ease;
	}

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(20px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	.modal-icon {
		margin-bottom: 1.5rem;
	}

	.modal-title {
		font-size: 1.5rem;
		font-weight: 600;
		color: #1d1d1f;
		margin: 0 0 1rem 0;
		letter-spacing: -0.02em;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-message {
		font-size: 1rem;
		color: #86868b;
		line-height: 1.5;
		margin: 0 0 2rem 0;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-actions {
		display: flex;
		gap: 0.75rem;
		justify-content: center;
	}

	.modal-button {
		flex: 1;
		padding: 0.875rem 1.5rem;
		font-size: 1rem;
		font-weight: 500;
		border: none;
		border-radius: 12px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-button.cancel {
		background: #f5f5f7;
		color: #1d1d1f;
	}

	.modal-button.cancel:hover {
		background: #e8e8ed;
	}

	.modal-button.confirm {
		background: #ff3b30;
		color: white;
	}

	.modal-button.confirm:hover {
		background: #ff453a;
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
	}

	.modal-button:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		.header-container {
			padding: 0.75rem 1rem;
		}

		.brand-logo {
			height: 32px;
		}

		.brand-name {
			font-size: 1.125rem;
		}

		.nav-actions {
			gap: 0.5rem;
		}

		.header-button {
			padding: 0.5rem 0.75rem;
			font-size: 0.875rem;
		}

		.modal-content {
			padding: 1.5rem;
		}

		.modal-actions {
			flex-direction: column;
		}

		.modal-button {
			width: 100%;
		}
	}

	/* Add these styles after the existing .header-button styles */

.resources-dropdown {
	position: relative;
}

.dropdown-chevron {
	transition: transform 0.2s ease;
	margin-left: 0.25rem;
}

.dropdown-chevron.open {
	transform: rotate(180deg);
}

.dropdown-menu {
	position: absolute;
	top: calc(100% + 0.5rem);
	right: 0;
	background: white;
	border-radius: 12px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border: 1px solid rgba(0, 0, 0, 0.08);
	min-width: 200px;
	overflow: hidden;
	animation: dropdownSlide 0.2s ease;
	z-index: 1001;
}

@keyframes dropdownSlide {
	from {
		opacity: 0;
		transform: translateY(-8px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.dropdown-item {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.875rem 1rem;
	color: #1d1d1f;
	text-decoration: none;
	transition: all 0.15s ease;
	font-size: 0.9375rem;
	font-weight: 500;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.dropdown-item:last-child {
	border-bottom: none;
}

.dropdown-item:hover {
	background: linear-gradient(90deg, rgba(49, 104, 50, 0.05) 0%, rgba(49, 104, 50, 0.02) 100%);
	color: var(--base-green);
}

.dropdown-item svg {
	color: var(--base-green);
	flex-shrink: 0;
}

.dropdown-item:hover svg {
	transform: scale(1.1);
}

.dropdown-item span {
	white-space: nowrap;
}

/* Mobile adjustments */
@media (max-width: 768px) {
	.resources-dropdown {
		position: static;
	}
	
	.dropdown-menu {
		right: 1rem;
		left: auto;
		min-width: 180px;
	}
	
	.dropdown-item {
		padding: 0.75rem 0.875rem;
		font-size: 0.875rem;
	}
	
	.header-button {
		white-space: nowrap;
	}
}

/* Very small screens - hide text, keep icons */
@media (max-width: 640px) {
	.nav-actions {
		gap: 0.375rem;
	}
	
	.header-button span {
		display: none;
	}
	
	.header-button {
		padding: 0.5rem;
		min-width: auto;
	}
	
	.dropdown-item span {
		font-size: 0.8125rem;
	}
}
</style>